import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CardPaginator = ({ currentPage, setCurrentPage, pages }) => {
  return (
    <div className="level-right">
      <div className="field is-grouped">
        <div className="field has-addons mb-0 mr-3">
          <p className="control">
            <button
              className="button is-light"
              disabled={currentPage === 0}
              onClick={() => {
                setCurrentPage(currentPage - 1);
              }}
            >
              <FontAwesomeIcon icon={["fas", "chevron-left"]} />
            </button>
          </p>
          <p className="control">
            <button className="button is-light">{currentPage + 1}</button>
          </p>
          <p className="control">
            <button
              className="button is-light"
              disabled={currentPage === pages - 1}
              onClick={() => {
                setCurrentPage(currentPage + 1);
              }}
            >
              <FontAwesomeIcon icon={["fas", "chevron-right"]} />
            </button>
          </p>
        </div>

        <div className="field" style={{ lineHeight: "40px" }}>
          <span>de {pages}</span>
        </div>
      </div>
    </div>
  );
};

export default CardPaginator;
